import React, {useRef} from "react";
import {useDispatch} from "react-redux";
import newUserSignUp, {SIGN_UP_STATE} from "../../Actions/signupAction";

const MoreDetails = ({setState, basicInfo}) => {
    const setPassRef = useRef(null);
    const confirmPassRef = useRef(null);
    const phoneRef = useRef(null);
    const emailRef = useRef(null);
    const signupRef = useRef(null);
    const dispatch = useDispatch();

    const handleNext = () => {
        setState("LOGGING_IN");
    }

    const handleBack = () => {
        setState("BASIC_INFO");
    }

    const handleSubmit = (ev) => {
        let phoneNumber = phoneRef.current.value;
        let email = emailRef.current.value;
        let password = setPassRef.current.value;

        console.log(phoneNumber, email, password, basicInfo);
        dispatch({
            type: SIGN_UP_STATE,
            payload: null
        })
        dispatch(newUserSignUp(basicInfo.companyName, phoneNumber, email, basicInfo.businessAddress, basicInfo.contactName, basicInfo.contactTitle, basicInfo.billingAddress, password, ""))
        handleNext();
    }

    const handlePassMatch = () => {
        if (confirmPassRef.current.value !== "" && setPassRef.current.value !== confirmPassRef.current.value) {
            console.log("Did not match");
            signupRef.current.disabled = true;
            confirmPassRef.current.style.border = "1px solid red";
        } else if (confirmPassRef.current.value === "") {
            confirmPassRef.current.style.border = "";
        } else {
            signupRef.current.disabled = false;
            confirmPassRef.current.style.border = "";
        }

    }

    return (
        <form className="d-flex flex-column sd-form" onSubmit={handleSubmit}>
            <div className="login-title">A few more details</div>
            <div className="d-flex flex-column">
                <label className="sd-label">Phone Number</label>
                <input ref={phoneRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Email</label>
                <input ref={emailRef} type="email" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Set Password</label>
                <input ref={setPassRef} type="password" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Confirm Password</label>
                <input onChange={handlePassMatch} ref={confirmPassRef} type="password" required={true}
                       className="sd-input"/>
            </div>
            <div className="d-flex justify-content-center text-center gap-8">
                <div className="login-btn login-secondary-btn w-100" onClick={handleBack}>Back</div>
                <input ref={signupRef} type="submit" className="login-btn login-primary-btn w-100"
                       value="Continue"></input>
            </div>
        </form>
    )
}

export default MoreDetails;
